import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

import { LoadingContainer } from '../styles';

interface LoadingStatusProps {
	message: string;
}

export default function LoadingStatus({ message }: LoadingStatusProps) {
	return (
		<LoadingContainer>
			<CircularProgress size={40} />
			<Typography variant="h6" color="textSecondary">
				{message}
			</Typography>
		</LoadingContainer>
	);
}
